import React from 'react';

export default class Revealer extends React.Component {
    constructor(props) {
        super(props);

        this.state = { value: 0 };
    }

    componentDidMount = () => {
        var reveal = () => {
            setTimeout(() => {
                this.setState({ value: this.state.value + 1 })
                if ((this.state.value + 1) <= this.props.text.length) reveal();
            }, 500);
        }
        reveal();
    }

    render() {
        return this.props.text.slice(0, this.state.value);
    }
}